import { rem } from "polished"

const bs = {
  card: `${rem(4)} ${rem(4)} ${rem(4)} rgba(0, 0, 0, 0.15)`,
}

export default bs
